'use client';
import { styled } from '@mui/material/styles';
export const SelectList = styled('div')(({ theme }) => ({
    paddingTop: theme.tokens.FuelSpacing2,
    paddingBottom: theme.tokens.FuelSpacing2
}));
